import { oc } from '@orpc/contract';
import { resetUserPasswordInputSchema, resetUserPasswordOutputSchema } from '../schemas/users.schemas.js';
export const resetUserPasswordContract = oc
    .route({
    method: 'POST',
    path: '/users/{userId}/reset-password',
    tags: ['Users'],
    summary: 'Issue a temporary password and force a change at the next sign-in',
})
    .input(resetUserPasswordInputSchema)
    .output(resetUserPasswordOutputSchema);
//# sourceMappingURL=reset-user-password.contract.js.map